/**
 * Carrega a data para sincronia com o servidor
 */
import axios from 'axios'

var serverTime = 0
var startTime = 0
var diffTime = 0
window.setTimeout(() => {
  axios.get(`${process.env.API_URL.replace('/app_dev.php', '')}/time/timestamp.php`)
    .then(function ({data}) {
      // serverTime = Number(data.toString()) * 1000
      serverTime = Date.parse(data.toString().replace(/ /g, 'T'))
      startTime = new Date().getTime()
      console.log(serverTime)
      let actualTime = new Date().getTime()
      diffTime = actualTime - startTime
      // serverTime = serverTime + diffTime + 1000
      // serverTime = serverTime + 1000
      console.log('O sistema levou ' + diffTime / 1000 + ' segundos para carregar o timestamp do servidor')
      console.log('A hora atual do servidor é: ' + new Date(serverTime))
      /* window.setInterval(() => {
        console.log('Server time:', new Date(serverTime))
        console.log('Time now:', new Date(timeNow()))
      }, 1000) */
    })
    .catch(function (response) {
      serverTime = 0
      alert('Não conseguimos sincronizar com o horário do servidor, seu cronômetro pode ter alguma inconsistência, mas você poderá dar lances normalmente, mas não confie no cronômetro e continue dando lantes imediatamente após algum outro lance cobrir o seu.')
      console.log(response)
    })
}, 50)

export const timeNow = function () {
  let timeAfterStart = new Date().getTime() - startTime
  let time = serverTime + timeAfterStart + 1000
  console.log('Time now:', new Date(time))
  return time
}

export {serverTime, startTime, diffTime}



// WEBPACK FOOTER //
// ./src/utils/services/pregao-server-time.js